import type { DesignScopeListItem } from "mock-data/design-scope";
import { ClassBadge } from "../components/scope-ui";

/** Code / title for one classification system, or the custom label. */
export function classParts(
  item: DesignScopeListItem,
  system: "uni-format" | "master-format"
) {
  const hit = item.classifications.find((c) => c.system === system);
  if (hit) {
    const code = hit.number ?? "";
    const title = hit.title ?? "";
    return {
      code,
      title,
      label: [code, title].filter(Boolean).join(" "),
      custom: false
    };
  }
  const custom = item.classifications.find((c) => c.system === "custom");
  if (custom?.title) {
    return { code: "", title: custom.title, label: custom.title, custom: true };
  }
  return { code: "", title: "", label: "", custom: false };
}

export function scopeTitle(item: DesignScopeListItem): string {
  if (item.title) return item.title;
  if (item.description) return item.description;
  const uniformat = item.classifications.find((c) => c.system === "uni-format");
  if (uniformat?.title) return uniformat.title;
  return item.classifications[0]?.title ?? "";
}

export function classificationCell(
  system: "UF" | "MF",
  code: string,
  title: string,
  custom = false
) {
  if (custom && title) {
    return (
      <span className="inline-flex min-w-0 items-center gap-1.5">
        <span className="shrink-0 rounded border border-solid border-ciq-gray-300 bg-ciq-black-a2 px-2 text-xs font-normal leading-5 text-ciq-black-a88">
          Custom
        </span>
        <span className="truncate">{title}</span>
      </span>
    );
  }
  if (!code && !title) return "—";
  return (
    <span className="inline-flex min-w-0 items-center gap-1.5">
      {code ? <ClassBadge system={system} code={code} /> : null}
      {title ? <span className="truncate">{title}</span> : null}
    </span>
  );
}
